var generateStyle = function generateStyle(componentTheme) {
  return {
    wrapper: {
      width: '100%',
      position: 'relative'
    },
    itemBody: {
      overflowX: 'visible',
      padding: "".concat(componentTheme.itemBodyPadding, " 0"),
      fontSize: componentTheme.itemBodyFontSize
    }
  };
};
export default generateStyle;